/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wacky_Full_Jay_AskInputs */

const fr_wacky_full_jay_ask = /** @type {(inputs: Wacky_Full_Jay_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des records personnels`)
};

/**

* @param {Wacky_Full_Jay_AskInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wacky_full_jay_ask = /** @type {((inputs?: Wacky_Full_Jay_AskInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wacky_Full_Jay_AskInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wacky_full_jay_ask(inputs)
});